import { Component, inject } from '@angular/core';
import { NgStyle } from '@angular/common';
import { Router } from '@angular/router';
import { CorporateDesignService } from '../../../../services/corporate-design/corporate-design.service';
import { OnDemandSelectionStateService } from '../../../../services/on-demand/on-demand-selection-state.service';
import { ERoute } from '../../../../constants/routes.enum';
import { UserStore } from '../../../../services/api/user/user/user-store.service';
import { OnDemandBookingStore } from '../../../../services/on-demand/on-demand-booking-store.service';
import { FilterTextsPipe } from '../../../../pipes/filterTexts/filterTexts.pipe';
import { LanguagePipe } from '../../../../pipes/language/language.pipe';
import { AUSTRIAN_PHONE_PREFIX, EEntityType, ERelationType } from '@web/dtos';
import { WebTextStore } from '../../../../services/api/text/web-text-store.service';
import { LoggingService } from '../../../../services/logging/logging.service';
import { OnDemandTicketConfigurationSummaryComponent } from '../on-demand-ticket-configuration-summary/on-demand-ticket-configuration-summary.component';
import { ButtonComponent } from '../../../../components/feedback/button/button.component';
import { OnDemandJourneyTimelineComponent } from '../on-demand-journey-timeline/on-demand-journey-timeline.component';
import { OnDemandJourneyViewModel } from '../on-demand-journey-view-model';

@Component({
  selector: 'aw-on-demand-ticket-configuration-reservation',
  templateUrl: './on-demand-ticket-configuration-reservation.component.html',
  imports: [
    NgStyle,
    FilterTextsPipe,
    LanguagePipe,
    OnDemandTicketConfigurationSummaryComponent,
    ButtonComponent,
    OnDemandJourneyTimelineComponent,
  ],
})
export class OnDemandTicketConfigurationReservationComponent {
  protected readonly ERelationType = ERelationType;
  protected readonly EEntityType = EEntityType;

  protected readonly corporateDesign = inject(CorporateDesignService);
  protected readonly textStore = inject(WebTextStore);
  protected readonly selectionState = inject(OnDemandSelectionStateService);
  protected readonly userStore = inject(UserStore);
  protected readonly journeyDisplay = inject(OnDemandJourneyViewModel);

  private readonly bookingStore = inject(OnDemandBookingStore);
  private readonly router = inject(Router);

  protected readonly ERoute = ERoute;

  constructor(private readonly log: LoggingService) {}

  protected navigateNext(): void {
    const user = this.userStore.user();
    if (user) {
      this.selectionState.passengerData.set({
        salutation: user.salutation || 'Herr',
        firstName: user.firstName || '',
        lastName: user.lastName || '',
        birthDate: user.birthDate
          ? new Date(user.birthDate).toLocaleDateString('de-AT', {
              day: '2-digit',
              month: '2-digit',
              year: 'numeric',
            })
          : '',
      });
      this.bookingStore.triggerReservation(
        this.selectionState.passengerCount(),
        `${user.firstName} ${user.lastName}`,
        user.email ?? '',
        user.phoneNumber
          ? user.phoneNumber.replace(/^0/, AUSTRIAN_PHONE_PREFIX)
          : undefined
      );
    }
    this.router
      .navigate([
        `/${ERoute.onDemandTicketConfiguration}/${ERoute.passengerData}`,
      ])
      .catch(err => this.log.error('Navigation failed', err));
  }
}
